import { __awaiter } from 'tslib';
import 'long';
import '../../proto/index.js';
import { ErrorType } from '../../core/consts.js';
import { Logger } from '../../core/metrics/logger.js';
import { BaseError } from '../../core/errors/BaseError.js';
import { Monitor, MonitorItem } from '../../core/metrics/monitor.js';
import '../../core/network/NetworkItem.js';
import { ServiceIdentity } from '../../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

var StorageMonitorItem;
(function (StorageMonitorItem) {
    StorageMonitorItem["ProxyInvoke"] = "storage.proxy.invoke";
    StorageMonitorItem["IntegrityConversationCheckBefore"] = "storage.integrity.conversation.before";
    StorageMonitorItem["IntegrityConversationCheckFix"] = "storage.integrity.conversation.fix";
    StorageMonitorItem["CacheInit"] = "storage.cache.init";
    StorageMonitorItem["CachePrune"] = "storage.cache.prune";
    StorageMonitorItem["CacheRetention"] = "storage.cache.retention";
    StorageMonitorItem["PassphraseError"] = "storage.passphrase.error";
    StorageMonitorItem["EncryptError"] = "storage.encrypt.error";
    StorageMonitorItem["DecryptError"] = "storage.decrypt.error";
})(StorageMonitorItem || (StorageMonitorItem = {}));
function StorageMetrics(target, name, descriptor) {
    const oldValue = descriptor.value;
    descriptor.value = function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            let startTime = 0;
            try {
                startTime = Monitor.performanceNow();
                const result = yield oldValue.call(this, ...args);
                this.resolve(ServiceIdentity.Monitor).emitDuration(StorageMonitorItem.ProxyInvoke + MonitorItem.SuccessSuffix, startTime, {
                    name
                });
                return result;
            }
            catch (error) {
                this.resolve(ServiceIdentity.Monitor).emitDuration(StorageMonitorItem.ProxyInvoke + MonitorItem.ErrorSuffix, startTime, {
                    name
                });
                Logger.ctxError(this.ctx, `db proxy op: ${name} error:`, error);
                throw new BaseError({
                    ctx: this.ctx,
                    type: ErrorType.DbOpError,
                    innerError: error,
                    sender: oldValue,
                    msg: `db proxy op: ${name} error`
                });
            }
        });
    };
    return descriptor;
}

export { StorageMetrics, StorageMonitorItem };
//# sourceMappingURL=StorageMetrics.js.map
